import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const SelectGuidelines = () => {
  const { t } = useTranslation();

  const tips = [
    t("ldp_explore_image_region_guideline_no_overlap"),
    t("ldp_explore_image_region_guideline_zoom"),
    t("ldp_explore_image_region_subtitle"),
  ];

  return (
    <Box
      sx={{
        backgroundColor: "var(--alias-background-white, #fff)",
        borderRadius: "var(--card-small, 8px)",
        border: "1px solid var(--alias-stroke-on-white-default, #d9d9d9)",
        boxShadow: "var(--elevation-sm, 0 1px 4px rgba(0,0,0,0.07))",
        padding: "var(--spacing14, 14px) var(--spacing16, 16px)",
      }}
    >
      <Typography
        component="span"
        sx={{
          fontFamily: "var(--body-b3-12-regular-font)",
          fontWeight: 500,
          fontSize: "var(--body-b3-12-regular-size, 12px)",
          color: "var(--alias-text-on-white-primary, #1a1a1a)",
        }}
      >
        {t("ldp_explore_image_region_guidelines_title")}
      </Typography>
      <Box
        component="ul"
        sx={{
          margin: "var(--spacing8, 8px) 0 0",
          padding: 0,
          listStyle: "none",
          display: "flex",
          flexDirection: "column",
          gap: "var(--spacing6, 6px)",
        }}
      >
        {tips.map((tip) => (
          <Box
            component="li"
            key={tip}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: "var(--spacing8, 8px)",
            }}
          >
            <Box
              sx={{
                width: 4,
                height: 4,
                borderRadius: "50%",
                backgroundColor: "var(--alias-surface-brand, #009FE4)",
                flexShrink: 0,
                marginTop: "var(--spacing6, 6px)",
              }}
            />
            <Typography
              sx={{
                fontFamily: "var(--body-b3-12-regular-font)",
                fontWeight: "var(--body-b3-12-regular-weight)",
                fontSize: "var(--body-b3-12-regular-size, 12px)",
                lineHeight: 1.5,
                color: "var(--alias-text-on-white-disable, #999999)",
              }}
            >
              {tip}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
